import {FB_SHARE_URL} from "modules/constants";
import {GameType, Language, ShareTarget} from "modules/enums";
import {ISharing} from "modules/types";

const getEncodedJson = <T>(object: T) => btoa(JSON.stringify(object));

export const getLinkForShare = <T>(object: T, locale: Language) => {
	const encodedJson = getEncodedJson(object);
	return `${FB_SHARE_URL}${locale}/general/${encodedJson}`;
};

const prepareShareObject = (data: ISharing) => {
	return {
		t: getTimestamp(),
		voteId: data.voteId,
		game: data.game,
	};
};

const last_four_number = -4;
const getTimestamp = () => Date.now().toString().substr(last_four_number);

export const shareFacebook = (data: ISharing) => {
	const object = prepareShareObject(data);
	const link = getLinkForShare(object, data.locale);

	const winWidth = 626;
	const winHeight = 436;
	const winTop = window.screen.height / 2 - winHeight / 2;
	const winLeft = window.screen.width / 2 - winWidth / 2;

	window.open(
		`https://www.facebook.com/sharer/sharer.php?display=popup&u=${link}`,
		"_blank",
		`top=${winTop},left=${winLeft},width=${winWidth}, height=${winHeight},toolbar=0,status=0,scrollbars=no,resizable=1`
	);
};

const getShareMessage = (game: GameType, lang: Language) => {
	const texts = {
		[GameType.FanFavorite]: {
			[Language.English]: "I just made my #CFLFanFavorite pick!",
			[Language.French]: "Je viens de voter pour mon joueur #PréféréDesPartisansLCF!",
		},
		[GameType.AllStar]: {
			[Language.English]: "I’ve made my 2024 All-CFL team selection!",
			[Language.French]: "J’ai fait ma sélection sur l’équipe d’étoiles de la LCF 2024 !",
		},
	};

	return texts[game][lang];
};

const shareTwitter = (data: ISharing) => {
	const object = prepareShareObject(data);
	const href = getLinkForShare(object, data.locale);
	window.open(
		`https://twitter.com/share?url=${encodeURIComponent(href)}&text=${encodeURIComponent(
			getShareMessage(data.game, data.locale)
		)}`,
		"twitter-share-dialog",
		"width=626,height=436"
	);
};

const shareNative = async (data: ISharing) => {
	try {
		const object = prepareShareObject(data);
		const href = getLinkForShare(object, data.locale);

		const shareData = {
			url: href,
			text: getShareMessage(data.game, data.locale),
		};

		await navigator.share(shareData);
	} catch (err) {
		const error = err as Error;
		console.warn(error.message);
	}
};

const shareMap = {
	[ShareTarget.Twitter]: shareTwitter,
	[ShareTarget.Facebook]: shareFacebook,
	[ShareTarget.Native]: shareNative,
} as const;

export const share = async (data: ISharing) => {
	const shareFunction = shareMap[data.target];

	if (shareFunction && typeof shareFunction === "function") {
		await shareFunction(data);
	}
};
